import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=5e32585a&scoped=true"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=5e32585a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32585a",
  null
  
)

export default component.exports